import React from 'react';
import SpinnerComponent from '../components/SpinnerComponent';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { AuthService } from '../services/authentication.service';


export class LoginPage extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        // redirect to home if already logged in
        if (AuthService.loggedIn()) { 
            this.props.history.push('/');
        }
    }

    onSuccess() {
        const { from } = this.props.location.state || { from: { pathname: "/" } };
        this.props.history.push(from);
    }

    render() {
        return (
            <div>
                <h1>Prijava</h1>
                <Formik
                    initialValues={{
                        username: '',
                        password: ''
                    }}
                    validationSchema={Yup.object().shape({
                        username: Yup.string().required('Korisničko ime je potrebno'),
                        password: Yup.string().required('Lozinka je obavezna')
                    })}
                    onSubmit={({ username, password }, { setStatus, setSubmitting }) => {
                        setStatus();
                        AuthService.login(username, password)
                            .then(
                                () => {
                                    this.onSuccess();
                                },
                                error => {
                                    setSubmitting(false);
                                    setStatus(error);
                                }
                            );
                    }}
                    render={({ errors, status, touched, isSubmitting }) => (
                        <Form>
                            <div className="form-group">
                                <label htmlFor="username">Korisničko ime</label>
                                <Field name="username" type="text" className={'form-control' + (errors.username && touched.username ? ' is-invalid' : '')} />
                                <ErrorMessage name="username" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="password">Lozinka</label>
                                <Field name="password" type="password" className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')} />
                                <ErrorMessage name="password" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group">
                                <button type="submit" className="btn btn-primary" disabled={isSubmitting}>Prijavi se</button>
                                {isSubmitting &&
                                    <SpinnerComponent/>
                                }
                            </div>
                            {status &&
                                <div className={'alert alert-danger'}>{status}</div>
                            }
                        </Form>
                    )}
                />
            </div>
        )
    }
}